// Reports Core Web Vitals to Sentry (as measurements/breadcrumbs) and
// Mixpanel (as `web_vital` events) so perf regressions show up in both the
// engineering and product dashboards.
//
// Called once from `app/bootstrap/initWebVitals.ts`. Cheap and idempotent.

import { onCLS, onINP, onFCP, onLCP, onTTFB, type Metric } from 'web-vitals'
import { logger } from '@core/logging/logger'
import { flags } from '@core/config'
import { analytics, ANALYTICS_EVENTS } from '../analytics'
import { SentryService } from '../sentry'

const report = (metric: Metric): void => {
  logger.info(`web vital ${metric.name}`, {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
  })

  analytics.track(ANALYTICS_EVENTS.WEB_VITAL, {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    delta: metric.delta,
  })

  SentryService.setTag(`web_vital.${metric.name.toLowerCase()}`, metric.rating)
}

export const initWebVitals = (): void => {
  if (!flags.webVitalsEnabled) return
  onCLS(report)
  onINP(report)
  onFCP(report)
  onLCP(report)
  onTTFB(report)
}
